import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncateStringParts' })
export class TruncateStringPartsPipe implements PipeTransform {
  public transform(value: string, partsCount: number = null, partitionBy: string = ' '): string {
    if (typeof value === 'string') {
      const units = value.split(partitionBy);
      if (partsCount && partsCount < units.length) return units.slice(0, partsCount).join(partitionBy);
    }
    return value;
  }
}
